import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { Location } from "@angular/common";
import { CoreLogService } from "../../services/log.service";
import { Router } from "@angular/router";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { CoreLanguageService } from "../../services/language.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs/Subscription";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { GroupOrderGuideService } from "./groupOrderGuide.service";
import { GroupOrderCreateGroupService } from "../groupOrderCreateGroup/groupOrderCreateGroup.service";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { AnnounceDialogComponent, WarningdialogComponent } from "../../modalDialogs";
import { AnounceModalResult } from "../../shared/contentTypes";
import { Observable } from "rxjs";
import { GroupStateService } from "../../services/groupState.service";

@Component({
  selector: "groupOrderGuide",
  templateUrl: "./groupOrderGuide.component.html",
  styleUrls: ["./groupOrderGuide.component.scss"],
  providers: [GroupOrderGuideService, GroupOrderCreateGroupService],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class GroupOrderGuideComponent implements OnInit, OnDestroy {

  private _langSubscriber: Subscription;
  public isGroupFull$: Observable<boolean>
  public isSmallView: boolean = false;
  
  constructor(private _location: Location
    , private _groupOrderGuideService: GroupOrderGuideService
    , private _router: Router
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _mainnavService: MainnavService
    , private _internationalisationService: InternationalisationService
    , private _coreLanguageService: CoreLanguageService
    , private _iosHelperService: IOSHelperService
    , private _groupStateService: GroupStateService
  ) {
    this.isSmallView = this._mainnavService.viewType === ViewType.Small;
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("GroupOrderGuideComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me._langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });

    me.isGroupFull$ = me._groupOrderGuideService.isGroupFull$
    me.PushChanges();
  }

  /** group created info text */
  public get groupCreatedInfo() {
    const me = this;
    return me._coreLanguageService.value("phGroupOrder_GroupCreated_Info")
      .replace("{groupName}", `<br><span class="emphasized">${me._groupOrderGuideService.groupName}</span><br>`);
  }

  /**Dialog: invite friends or put order*/
  public openAnnounceDialog() {
    const me = this;
    const warningDialog = me._bottomSheetHelperService.open(AnnounceDialogComponent, {
      data: {
        title: "phGroupOrder_InviteFriends_Dialog_Title"
        , content: "phGroupOrder_InviteFriends_Dialog_SubText"
        , firstBtnLabel: "phGroupOrder_InviteFriends_Dialog_OrderBtn"
        , secondBtnLabel: "phGroupOrder_InviteFriends_Dialog_InviteBtn"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningDialog.afterDismissed().subscribe((result: AnounceModalResult) => {
      if (result === AnounceModalResult.FirstButton) {
        me._router.navigate(["/menugroup"]);
      } else if (result === AnounceModalResult.SecondButton) {
        me._router.navigate(["/groupOrderShare"]);
      } else {
        // nothing
      }
    });
  }

  /** Warning dialog: Group full */
  public OpenWarningGroupFull() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phGroupOrder_GroupFull_Title"
        , content: "phGroupOrder_GroupFull_SubText"
        , btnLabel: "phGroupOrder_GroupFull_Btn"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningButtomSheet.afterDismissed().subscribe((result) => {
      if (result) {
        me._router.navigate(["/menuservice"]);
      }
    });
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  /** Navigate to GroupOrderInvite view */
  public NavigateToShare() {
    const me = this;
    me._groupStateService.setshownavigatetomenu(true);
    me._router.navigate(['/groupOrderShare']);
  }
  
  /** navigate to menu */
  public NavigateToMenu() {
    const me = this;
    me.openAnnounceDialog();
  }

  /** navigate back */
  public navigateBack(): void {
    //! todo es muss das native zorück abfangen
    //! todo es muss fragen ob man wirklich die gurppe verlassen möchte
    const me = this;
    me._router.navigate(["/"]); // Home
  }
}
